import * as types from './types';
import { loading } from 'State/actions';
import { fetchGeneric } from 'State/generic/actions';

export const getUnappliedStudentsReport = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.UNAPPLIED_STUDENTS_REPORT_LOADING, true));

    try {
      const response = await MPWWebAPI.postGenericInsertUpdate(
        'Reports/unappliedstudentsreport',
        data
      );
      dispatch({
        type: types.UNAPPLIED_STUDENTS_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.UNAPPLIED_STUDENTS_REPORT_LOAD_ERROR,
        loadError: error.response.Errors,
      });
    }

    dispatch(loading(types.UNAPPLIED_STUDENTS_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.UNAPPLIED_STUDENTS_REPORT_GET_REPORT,
    payload: null,
  };
};

export const setSelectedSites = selectedSites => {
  return async dispatch => {
    return dispatch({
      type: types.UNAPPLIED_STUDENTS_REPORT_SET_SELECTED_SITES,
      payload: selectedSites,
    });
  };
};

export const clearErrors = () => {
  return {
    type: types.UNAPPLIED_STUDENTS_REPORT_CLEAR_ERRORS,
  };
};

export const getGrades = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.UNAPPLIED_STUDENTS_REPORT_GET_GRADES,
        types.UNAPPLIED_STUDENTS_REPORT_LOADING,
        types.UNAPPLIED_STUDENTS_REPORT_LOAD_ERROR,
        'Grade'
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/state/report/actions.js